<div class="core-ui-date-range" [class.is-open]="isOpen" #root>
    <button *ngIf="!externalTrigger" #control type="button" class="core-ui-date-range__control" [class.is-filled]="isFilled"
        [class.is-readonly]="readOnly" (click)="toggleDropdown()" [disabled]="disabled">
        <div class="core-ui-date-range__left">
            <core-ui-icon name="icon_calendar" [color]="iconColor" class="core-ui-date-range__icon"></core-ui-icon>

            <div class="core-ui-date-range__texts">
                <span class="core-ui-date-range__label">
                    {{ label }}
                </span>

                <span class="core-ui-date-range__value" [class.is-placeholder]="isPlaceholder"
                    [class.is-filled-text]="isFilled">
                    {{ displayValue || placeholder }}
                </span>
            </div>
        </div>

        <div class="core-ui-date-range__chevron" *ngIf="!hideChevron">
            <core-ui-icon name="chevron" [size]="sizeIcon" [direction]="isOpen ? 'up' : 'down'" [color]="'#5F7081'"
                [extraClass]="'klab-sidebar__item-chevron'">
            </core-ui-icon>
        </div>
    </button>

    <div class="core-ui-date-range__custom" *ngIf="isOpen" #dropdown [ngStyle]="dropdownStyle">
        <div class="kd-calendars">
            <!-- Calendario izquierdo -->
            <div class="kd-calendar">
                <div class="kd-calendar__header">
                    <button *ngIf="canGoPrevMonth" type="button" class="kd-calendar__nav-btn" (click)="onPrevMonth()">
                        <core-ui-icon name="chevron" [direction]="'left'"></core-ui-icon>
                    </button>

                    <span class="kd-calendar__month-label">
                        {{ leftMonthLabel }}
                    </span>
                </div>

                <div class="kd-calendar__weekdays">
                    <span *ngFor="let wd of weekDays">{{ wd }}</span>
                </div>

                <div class="kd-calendar__grid">
                    <button type="button" class="kd-calendar__day" *ngFor="let day of leftMonthDays"
                        [class.is-outside]="day.isOutside" [class.is-start]="isStart(day.date)"
                        [class.is-end]="isEnd(day.date)" [class.is-in-range]="isInRange(day.date)"
                        [class.is-today]="!day.isOutside && isToday(day.date)"
                        [class.kd-has-range]="hasRange" [class.is-disabled]="isDisabledDay(day.date)"
                        [class.is-out-window]="isOutOfRangeWindow(day.date)" [disabled]="isDisabledDay(day.date)"
                        [attr.aria-current]="!day.isOutside && isToday(day.date) ? 'date' : null"
                        (click)="onSelectDate(day.date)">
                        <span class="kd-calendar__day-inner">
                            {{ day.label }}
                        </span>
                    </button>
                </div>
            </div>

            <!-- Calendario derecho -->
            <div class="kd-calendar">
                <div class="kd-calendar__header kd-calendar__header--right">
                    <span class="kd-calendar__month-label">
                        {{ rightMonthLabel }}
                    </span>

                    <button *ngIf="canGoNextMonth" type="button" class="kd-calendar__nav-btn" (click)="onNextMonth()">
                        <core-ui-icon name="chevron" [direction]="'right'"></core-ui-icon>
                    </button>
                </div>

                <div class="kd-calendar__weekdays">
                    <span *ngFor="let wd of weekDays">{{ wd }}</span>
                </div>

                <div class="kd-calendar__grid">
                    <button type="button" class="kd-calendar__day" *ngFor="let day of rightMonthDays"
                        [class.is-outside]="day.isOutside" [class.is-start]="isStart(day.date)"
                        [class.is-end]="isEnd(day.date)" [class.is-in-range]="isInRange(day.date)"
                        [class.is-today]="!day.isOutside && isToday(day.date)"
                        [class.kd-has-range]="hasRange" [class.is-disabled]="isDisabledDay(day.date)"
                        [class.is-out-window]="isOutOfRangeWindow(day.date)" [disabled]="isDisabledDay(day.date)"
                        [attr.aria-current]="!day.isOutside && isToday(day.date) ? 'date' : null"
                        (click)="onSelectDate(day.date)">
                        <span class="kd-calendar__day-inner">
                            {{ day.label }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
